import { buildImportPreview, parseExportEnvelope, type ImportPreview } from '../../domain/backup/ExportEnvelope';
import { failure, success, type Result } from '../../domain/shared/Result';
import { RoutineError, toRoutineError } from '../errors/RoutineError';

export interface ImportFilePreview {
  readonly envelope: ReturnType<typeof parseExportEnvelope>;
  readonly preview: ImportPreview;
}

/** Parses and validates a candidate import file without writing anything (AC-L0-IMP-02). */
export class PreviewImportFile {
  public execute(rawJson: string): Result<ImportFilePreview, RoutineError> {
    try {
      const envelope = parseExportEnvelope(rawJson);
      return success({ envelope, preview: buildImportPreview(envelope) });
    } catch (error) {
      return failure(toRoutineError(error));
    }
  }
}
